import React, { useState, useEffect } from "react";
import packageJson from '../../../package.json';

const BASE_URL = packageJson.apiUrl;

const CourseLeft = ({ course }) => {
  // Managing active index for carousel indicators
 const [activeIndex, setActiveIndex] = useState(0);
const [faqData, setFaqData] = useState([]);
  // List of gallery images
  const galleryImages = [
    { src: course?.image, alt: "Course Image" },
    { src: course?.gallery1, alt: "Gallery Image 1" },
    { src: course?.gallery2, alt: "Gallery Image 2" },
    { src: course?.gallery3, alt: "Gallery Image 3" }
  ];

  // Filtering out null images
  const filteredImages = galleryImages.filter(image => image.src);
useEffect(() => {
  const fetchFaqData = async () => {
    if (course?.id) {
      try {
        const response = await fetch(`${BASE_URL}/coursefaq/${course.id}`);
        const data = await response.json();
        console.log("Fetched FAQ data:", data);
        if (data.success && Array.isArray(data.data)) {
          setFaqData(data.data);
        }
      } catch (error) {
        console.error("Error fetching FAQ data:", error);
      }
    }
  };

  fetchFaqData();
}, [course?.id]);


  return (
    <>
      <div className="cr-img">
        <div className="row">
          <div className="col-lg-12">
            <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
              <div className="carousel-indicators">
                {filteredImages.map((image, index) => (
                  <button
                    key={index}
                    type="button"
                    data-bs-target="#carouselExampleControls"
                    data-bs-slide-to={index}
                    className={activeIndex === index ? "active" : ""}
                    aria-current={activeIndex === index ? "true" : "false"}
                    aria-label={`Slide ${index + 1}`}
                    onClick={() => setActiveIndex(index)} // Update active index on indicator click
                  ></button>
                ))}
              </div>
              <div className="carousel-inner">
                {filteredImages.map((image, index) => (
                  <div
                    key={index}
                    className={`carousel-item ${activeIndex === index ? "active" : ""}`}
                  >
                    <img src={image.src} className="img-fluid rounded d-block w-100" alt={image.alt} />
                  </div>
                ))}
              </div>

              <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
              </button>
              <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Description Section */}
      <div className="cr-card">
        <div className="cr-card-head">
          <h3 className="cr-title">Description​​</h3>
        </div>
        <div className="cr-card-body">
          <p dangerouslySetInnerHTML={{ __html: course?.description }} />
        </div>
      </div>

      {/* What You'll Learn Section */}
      <div className="cr-card">
        <div className="cr-card-head">
          <h3 className="cr-title">What you'll Learn​​</h3>
        </div>
        <div className="cr-card-body">
          
              <p dangerouslySetInnerHTML={{ __html: course?.what_you_learn }} />
        
        </div>
      </div>

      {/* Method of Assessment */}
      <div className="cr-card">
        <div className="cr-card-head">
          <h3 className="cr-title">Method of Assessment​​​</h3>
        </div>
        <div className="cr-card-body">
         <p dangerouslySetInnerHTML={{ __html: course?.MOA }} />
        </div>
      </div>

      {/* Certification Section */}
      <div className="cr-card">
        <div className="cr-card-head">
          <h3 className="cr-title">Certification​​​</h3>
        </div>
        <div className="cr-card-body">
              <p dangerouslySetInnerHTML={{ __html: course?.certification }} />
        </div>
      </div>

      {/* Key Features Section */}
      <div className="cr-card">
        <div className="cr-card-head">
          <h3 className="cr-title">Key Features​</h3>
        </div>
        <div className="cr-card-body">
          <p dangerouslySetInnerHTML={{ __html: course?.key_features }} />
        </div>
      </div>

      {/* Endorsement Section */}
      <div className="cr-card">
        <div className="cr-card-head">
          <h3 className="cr-title">Endorsement​​</h3>
        </div>
        <div className="cr-card-body">
           <p dangerouslySetInnerHTML={{ __html: course?.endorsement }} />
        </div>
      </div>

      {/* Why Study This Course Section */}
      <div className="cr-card">
        <div className="cr-card-head">
          <h3 className="cr-title">Why Study This Course​​​</h3>
        </div>
        <div className="cr-card-body">
            <p dangerouslySetInnerHTML={{ __html: course?.why_study_this_course }} />
        </div>
      </div>

    {/* FAQ Section */}
      {/* <div className="cr-card">
        <div className="cr-card-head">
          <h3 className="cr-title">Frequently Asked Questions​​</h3>
        </div>
        <div className="cr-card-body">
          <div className="accordion" id="accordionExample">
           {faqData.length > 0 ? (
              faqData.map((faq, index) => (
                <div className="accordion-item" key={faq.id}>
                  <h2 className="accordion-header" id={`heading${faq.id}`}>
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse${faq.id}`}
                      aria-expanded={activeIndex === index ? "true" : "false"} // Dynamically control expand/collapse
                      aria-controls={`collapse${faq.id}`}
                      onClick={() => setActiveIndex(index)} // Update active index on click
                    >
                      {faq.question}
                    </button>
					
                  </h2>
                  <div
                    id={`collapse${faq.id}`}
                    className={`accordion-collapse collapse ${activeIndex === index ? "show" : ""}`} // Dynamically apply the "show" class
                    aria-labelledby={`heading${faq.id}`}
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <p>{faq.anwser}</p>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p>Loading FAQs...</p>
            )}
          </div>
        </div>
      </div> */}
    </>
  );
};

export default CourseLeft;
